// extracted by mini-css-extract-plugin
export var askAiIcon = "_ri-9";
export var container = "_ri-0";
export var groupSeparator = "_ri-a";
export var highlight = "_ri-4";
export var resultIcon = "_ri-5";
export var resultItem = "_ri-7";
export var resultSubtitle = "_ri-3";
export var resultTitle = "_ri-2";
export var resultsList = "_ri-1";
export var searchGroup = "_ri-6";
export var selected = "_ri-8";